import forAna from '../../../assets/images/production/forAnaSeries/forAna.png'
import leftBall from '../../../assets/images/production/forAnaSeries/left-ball.png'

import styles from './style.module.scss'

function ForensicAnalysisSeries() {
    return (
        <div className={`production-series-wrapper  ${styles['for-ana-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">电子取证产品</div>
                <div className="content">构建多源数据采集接入能力、贴合业务场景的取证分析能力，打造了“多场景、多形态、高性能、高产出” 的电子取证产品体系，满足现场勘查、终端取证、证据分析、电子物证实验室等各类业务场景。</div>
            </div>
            <div className={`series-container ${styles['series-container']}`}>
                <div className={`series-content ${styles['series-content']}`}>
                    <img src={leftBall} alt="" />
                    <div>
                        <div className={`introduction-title ${styles['introduction-title']}`}>
                            <p><span>取证分析系列</span><span>—— 让电子数据赋能侦查打击</span></p>
                            <p>“辰星”智能取证分析平台是一款电子取证数据的综合业务应用平台。该产品支持对取证数据多源汇聚管理，同时提供取证数据考核统计、多维度分析研判、线索推荐模型等功能，为案件侦破提供及时有效的线索挖掘以及研判分析依据。</p>
                        </div>
                        <img src={forAna} alt="" />
                    </div>
                    <div className={styles['introduction-container']}>
                         <div className={`introduction-item ${styles['introduction-item']}`}>
                            <div className={styles['img']}></div>
                            <div className={styles['introduction-content']}>
                                <p>数据分析高效化</p>
                                <p>将知识图谱、NLP、多媒体等技术与数据分析相结合，大幅提升案件打击成效；</p>
                            </div>
                        </div>
                         <div className={`introduction-item ${styles['introduction-item']}`}>
                            <div className={styles['img']}></div>
                            <div className={styles['introduction-content']}>
                                <p>案件侦办智能化</p>
                                <p>侦办思路沉淀为脑图知识库，智能化引导案件侦办；</p>
                            </div>
                        </div>
                         <div className={`introduction-item ${styles['introduction-item']}`}>
                            <div className={styles['img']}></div>
                            <div className={styles['introduction-content']}>
                                <p>线索推荐自动化</p>
                                <p>案件技战法智能转化为数据模型，为案件研判分析提供有力支撑；</p>
                            </div>
                        </div>
                         <div className={`introduction-item ${styles['introduction-item']}`}>
                            <div className={styles['img']}></div>
                            <div className={styles['introduction-content']}>
                                <p>协同办公规范化</p>
                                <p>打通与外部系统的连接通道，满足多警种合成作战的应用场景。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForensicAnalysisSeries